import React from 'react';

import Loader from "../../../components/Loader";
import {OptionalContent} from "../../../components/OptionalContent";
import AbitAccountForm from "./AbitAccountForm";
import useAbitAccounts from "./useAbitAccounts";

import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions/CardActions";
import List from "@mui/material/List";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Container from "@mui/material/Container";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItemButton from "@mui/material/ListItemButton";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";


const AbitAccountsCard = () => {

    const {
        isLoading,
        abitAccounts,
        formCreate,
        formEdit,
        handleEditAccount,
        selectedAccount,
        handleDelete
    } = useAbitAccounts()

    return (
        <Card>
            <CardContent>
                <Container maxWidth='sm' disableGutters sx={{position: "relative"}}>
                    <Loader isLoading={isLoading}>
                        <OptionalContent hasContent={abitAccounts.length > 0}
                                         noContentMessage="Nessun account abit presente."
                                         showIcon>
                            <List>
                                {
                                    abitAccounts.map((a, i) => (
                                        <React.Fragment key={a.id}>
                                            <ListItem disablePadding>
                                                <ListItemButton disableGutters onClick={() => handleEditAccount(a)}>
                                                    <ListItemText primary={a.nickname} secondary={a.username}/>
                                                    <IconButton>
                                                        <EditIcon/>
                                                    </IconButton>
                                                    <IconButton onClick={(e) => handleDelete(e, a.id)}>
                                                        <DeleteIcon/>
                                                    </IconButton>
                                                </ListItemButton>
                                            </ListItem>
                                            {i !== abitAccounts.length - 1 && <Divider/>}
                                        </React.Fragment>
                                    ))
                                }
                            </List>
                        </OptionalContent>
                    </Loader>
                </Container>
            </CardContent>

            <CardActions sx={{justifyContent: "flex-end", py: 2, px: 3}}>
                <Button type="submit" variant="contained" onClick={formCreate.open}>
                    Aggiungi account
                </Button>
            </CardActions>

            {formEdit.show && <EditDialog onClose={formEdit.close} account={selectedAccount}/>}
            {formCreate.show && <CreateDialog onClose={formCreate.close}/>}
        </Card>
    );
};

const CreateDialog = (props) => {
    const {onClose} = props;
    const {createAbitAccount} = useAbitAccounts();

    const handelCreate = async (data) => {
        await createAbitAccount(data);
        onClose();
    }

    return <Dialog fullWidth open={true} onClose={onClose}>
        <DialogTitle>Crea nuovo account</DialogTitle>
        <DialogContent>
            <AbitAccountForm onSave={handelCreate}/>
        </DialogContent>
    </Dialog>

}

const EditDialog = (props) => {
    const {onClose, account} = props;
    const {updateAbitAccount, isUpdating} = useAbitAccounts();

    const handleEdit = async (data) => {
        await updateAbitAccount({id: account.id, ...data});
        onClose();
    }

    return <Dialog fullWidth open={true} onClose={onClose}>
        <DialogTitle>Configura Account Abit</DialogTitle>
        <DialogContent>
            <AbitAccountForm onSave={handleEdit} account={account} isSaving={isUpdating}/>
        </DialogContent>
    </Dialog>

}

export default AbitAccountsCard;